import OrdersRepository from 'client-sdk/src/Repository/orders-repository';
import ActionRepository from 'client-sdk/src/Repository/action-repository';
import {takeLatest, put} from 'redux-saga/effects';
import translateErrors from '../../utils/text/translate/translateErrors';
import {
  GET_ORDERS,
  GET_ORDERS_SUCCESS,
  GET_ORDERS_FAILED,
  GET_CAT,
  GET_CAT_SUCCESS,
  GET_CAT_FAILED,
  UPDATE_ORDER_STATUS,
  UPDATE_ORDER_STATUS_SUCCESS,
  UPDATE_ORDER_STATUS_FAILED,
  UPDATE_ORDER_SUCCESS,
  UPDATE_ORDER_FAILED,
  GET_ORDER_WITH_ID,
  GET_ORDER_WITH_ID_SUCCESS,
  GET_ORDER_WITH_ID_FAILED,
  ACTION_RETRIEVE_RUBIKA_ORDERS,
  ACTION_RETRIEVE_RUBIKA_ORDERS_SUCCESS,
  ACTION_RETRIEVE_RUBIKA_ORDERS_FAILED,
  SCHEDULE_ORDERS,
  SCHEDULE_ORDERS_SUCCESS,
  SCHEDULE_ORDERS_FAILED,
  CANCEL_ORDER,
  CANCEL_ORDER_SUCCESS,
  CANCEL_ORDER_FAILED,
  GET_LOGS_SUCCESS,
  GET_LOGS_FAILED,
  GET_LOGS,
  CREATE_ORDER_ITEMS_SUCCESS,
  CREATE_ORDER_ITEMS,
  GET_ALL_ORDERS_REPORT,
  GET_ALL_ORDERS_REPORT_SUCCESS,
  GET_ALL_ORDERS_REPORT_FAILED,
  UPDATE_ALL_ORDER_STATUS,
  UPDATE_ALL_ORDER_STATUS_SUCCESS,
  UPDATE_ALL_ORDER_STATUS_FAILED,
  CREATE_POST_ORDERS,
  CREATE_POST_ORDERS_SUCCESS,
  CREATE_POST_ORDERS_FAILED,
  GET_POST_ORDERS_SUCCESS,
  GET_POST_ORDERS_FAILED,
  GET_POST_ORDERS,
  DELETE_POST_ORDER,
  DELETE_POST_ORDER_SUCCESS,
  DELETE_POST_ORDER_FAILED,
  GET_ORDER_ITEMS_SUCCESS,
  GET_ORDER_ITEMS_FAILED,
  GET_ORDER_ITEMS,
  RESEND_ORDER,
  RESEND_ORDERS_FAILED,
  RESEND_ORDERS_SUCCESS,
  UPDATE_ORDER,
  GET_TICKETS,
  GET_TICKETS_SUCCESS,
  GET_TICKETS_FAILED,
  GET_TICKETCOUNT_SUCCESS,
  GET_TICKETCOUNT_FAILED,
  GET_TICKETCOUNT,
  GET_TICKET_FAILED,
  GET_TICKET_SUCCESS,
  GET_TICKET,
  CLOSE_TICKET_SUCCESS,
  CLOSE_TICKET_FAILED,
  CLOSE_TICKET,
  GET_VITRIN_ORDERS,
  GET_VITRIN_ORDERS_SUCCESS,
  GET_VITRIN_ORDERS_FAILED,
  GET_INCOMING_ORDERS,
  GET_INCOMING_ORDERS_SUCCESS,
  GET_INCOMING_ORDERS_FAILED,
  GET_VITRIN_ORDER_WITH_ID,
  GET_VITRIN_ORDER_WITH_ID_SUCCESS,
  GET_VITRIN_ORDER_WITH_ID_FAILED,
} from './constants';
import {
  CreateOrderItemsRequestBuilder,
  UpdateOrderRequestBuilder,
} from 'client-sdk/src/orders/orders';

import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotfication';
import Client from 'client-sdk/src/client';
import {GetAllCategoriesRequestBuilder} from 'client-sdk/src/helpical/categories';

const token = localStorage.getItem('token') || '';

export function* getOrders(actions: any): unknown {
  let deliveringCount,
    deliveredCount,
    processingCount,
    deliverdPostCount,
    returnedCount;
  const {noCount, ...otherActions} = actions.payload;
  try {
    const {response, count} = yield OrdersRepository.getOrders({
      payload: {...otherActions},
      sort: 'id,desc',
    });
    if (noCount) {
      yield put({
        type: GET_ORDERS_SUCCESS,
        data: response.data,
        count: count.data,
        deliveringCount: deliveringCount,
        deliveredCount: deliveredCount,
        processingCount: processingCount,
        deliverdPostCount: deliverdPostCount,
        returnedCount: returnedCount,
      });

      return;
    }
    deliveringCount = yield OrdersRepository.getOrdersCount({
      ...otherActions,
      sort: 'id,desc',
      'status.in': ['LOADED', 'DELIVERED_TO_COURIER'],
    });
    deliveredCount = yield OrdersRepository.getOrdersCount({
      ...otherActions,
      sort: 'id,desc',
      'status.in': ['DELIVERED'],
    });
    processingCount = yield OrdersRepository.getOrdersCount({
      ...otherActions,
      sort: 'id,desc',
      'status.in': ['ASSIGNED', 'PICKED', 'PACKAGED', 'BUNDLED'],
    });
    deliverdPostCount = yield OrdersRepository.getOrdersCount({
      ...otherActions,
      sort: 'id,desc',
      'status.in': ['DELIVERED_TO_POST'],
    });
    returnedCount = yield OrdersRepository.getOrdersCount({
      ...otherActions,
      sort: 'id,desc',
      'status.in': ['RETURNED'],
    });

    yield put({
      type: GET_ORDERS_SUCCESS,
      data: response.data,
      count: count.data,
      deliveringCount: deliveringCount.response.data,
      deliveredCount: deliveredCount.response.data,
      processingCount: processingCount.response.data,
      deliverdPostCount: deliverdPostCount.response.data,
      returnedCount: returnedCount.response.data,
    });
  } catch (error) {
    yield put({
      type: GET_ORDERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}
export function* getVitrinOrders(actions: any): unknown {
  const {...otherActions} = actions.payload;
  try {
    const response = yield OrdersRepository.getVitrinOrders({
      payload: {...otherActions},
      sort: 'id,desc',
    });
    yield put({
      type: GET_VITRIN_ORDERS_SUCCESS,
      data: response.data,
      count: response.headers['x-total-count'],
    });
  } catch (error) {
    yield put({
      type: GET_VITRIN_ORDERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}
export function* getIncomingOrders(actions: any): unknown {
  const {...otherActions} = actions.payload;
  try {
    const response = yield OrdersRepository.getIncomingOrders({
      payload: {...otherActions},
      sort: 'id,desc',
    });
    yield put({
      type: GET_INCOMING_ORDERS_SUCCESS,
      data: response.data,
      count: response.headers['x-total-count'],
    });
  } catch (error) {
    yield put({
      type: GET_INCOMING_ORDERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}
export function* getCatgories(actions: any): unknown {
  try {
    const response = yield OrdersRepository.getHelpical({
      ...actions,
    });

    yield put({
      type: GET_CAT_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_CAT_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}
export function* getTickets(actions: any): unknown {
  try {
    const response = yield OrdersRepository.getHelpicalTickets({
      ...actions.payload,
    });

    yield put({
      type: GET_TICKETS_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_TICKETS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}
export function* getTicket(actions: any): unknown {
  try {
    const response = yield OrdersRepository.getHelpicalTicket({
      ...actions.payload,
    });

    yield put({
      type: GET_TICKET_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_TICKET_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}
export function* closeTicket(actions: any): unknown {
  const {payload} = actions;
  try {
    const response = yield OrdersRepository.closeHelpicalTicket({
      ...payload.payload,
    });

    yield put({
      type: CLOSE_TICKET_SUCCESS,
      data: response.data,
    });
    payload.callback && payload.callback();
  } catch (error) {
    yield put({
      type: CLOSE_TICKET_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}
export function* getTicketsCount(actions: any): unknown {
  try {
    const {response} = yield OrdersRepository.getHelpicalTicketsCount(actions);
    yield put({
      type: GET_TICKETCOUNT_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_TICKETCOUNT_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getAllOrderItems(actions: any): unknown {
  try {
    const response = yield OrdersRepository.getAllOrderItems(actions);
    yield put({
      type: GET_ORDER_ITEMS_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_ORDER_ITEMS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getOrderWithId(actions: any): unknown {
  try {
    const response = yield OrdersRepository.getOrderWithId(actions);
    yield put({
      type: GET_ORDER_WITH_ID_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_ORDER_WITH_ID_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}
export function* getVitrinOrderWithId(actions: any): unknown {
  try {
    const response = yield OrdersRepository.getVitrinOrderWithId(actions);
    yield put({
      type: GET_VITRIN_ORDER_WITH_ID_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_VITRIN_ORDER_WITH_ID_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* actionRetrieveRubikaOrders(actions: any): unknown {
  try {
    const response = yield ActionRepository.actionRetrieveRubikaOrders(actions);
    yield put({
      type: ACTION_RETRIEVE_RUBIKA_ORDERS_SUCCESS,
      data: response.data,
    });
    response.data.length === 0
      ? handleNotfication('سفارش جدیدی اضافه نشده است', 'warn')
      : handleNotfication('سفارش جدیدی اضافه شد', 'success');
    yield put({
      type: GET_ORDERS,
      payload: {page: 0, size: 10, sort: 'created,desc'},
    });
  } catch (error) {
    yield put({
      type: ACTION_RETRIEVE_RUBIKA_ORDERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* scheduleOrdersSaga(actions: any): unknown {
  try {
    const response = yield ActionRepository.scheduleOrders(actions);
    yield put({
      type: SCHEDULE_ORDERS_SUCCESS,
      data: response.data,
    });
    handleNotfication(
      'ایجاد و تخصیص اتوماتیک بسته با موفقیت انجام شد ',
      'success'
    );
  } catch (error) {
    yield put({
      type: SCHEDULE_ORDERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* createOrderItems(actions: any): unknown {
  const {id, body, callback} = actions.payload;
  try {
    const makeCreateOrderItemsReq = new CreateOrderItemsRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    yield client.execute(makeCreateOrderItemsReq);
    yield put({
      type: CREATE_POST_ORDERS_SUCCESS,
    });
    yield put({
      type: GET_ORDER_ITEMS,
      payload: {'orderId.equals': id, size: 100},
    });
    callback && callback();
    handleNotfication('آیتم مورد نظر با موفقیت اضافه شد', 'success');
  } catch (error) {
    yield put({
      type: CREATE_ORDER_ITEMS_SUCCESS,
    });
    translateErrors(error?.response?.data?.title)
      ? handleNotfication(
          translateErrors(error?.response?.data?.title),
          'error'
        )
      : handleNotfication(
          'اضافه کردن آیتم مورد نظر با موفقیت انجام نشد',
          'error'
        );
  }
}

export function* updateOrderStatus(actions: any): unknown {
  const {pagination, callback} = actions.payload;
  try {
    yield OrdersRepository.updateOrderStatus(actions);
    yield put({
      type: UPDATE_ORDER_STATUS_SUCCESS,
    });
    yield put({
      type: GET_ORDERS,
      payload: {...pagination, sort: 'created,desc'},
    });
    callback && callback();
    handleNotfication('تغییر وضعیت سفارش با موفقیت انجام شد', 'success');
  } catch (error) {
    yield put({
      type: UPDATE_ORDER_STATUS_FAILED,
      error: error.message,
    });
    handleNotfication('تغییر وضعیت سفارش انجام نشد', 'error');
  }
}

export function* updateOrder(actions: any): unknown {
  const {body, callback} = actions.payload;
  try {
    const updateOrderReq = new UpdateOrderRequestBuilder().data(body).build();
    const client = new Client(token);
    yield client.execute(updateOrderReq);
    yield put({
      type: UPDATE_ORDER_SUCCESS,
      payload: {sort: 'created,desc'},
    });
    handleNotfication('سفارش با موفقیت ویرایش شد', 'success');
    callback();
  } catch (error) {
    yield put({
      type: UPDATE_ORDER_FAILED,
    });
    handleError(error.response);
    handleNotfication('ویرایش سفارش انجام نشد دوباره تلاش کنید', 'error');
  }
}
export function* createPostOrder(actions: any): unknown {
  const {body, callback} = actions.payload;
  try {
    const {response} = yield OrdersRepository.createPostOrder(actions);
    yield put({
      type: CREATE_POST_ORDERS_SUCCESS,
      data: response.data,
    });
    callback && callback();
    if (!body.send)
      handleNotfication('سفارش پستی شما با موفقیت ارسال شد', 'success');
  } catch (error) {
    yield put({
      type: CREATE_POST_ORDERS_FAILED,
      error: error.message,
    });
    if (!body.send) {
      handleNotfication('سفارش پستی شما ارسال نشد', 'error');
    }
  }
}
export function* resendOrders(actions: any): unknown {
  const {callback} = actions.payload;
  try {
    yield OrdersRepository.resendOrders(actions);
    yield put({
      type: RESEND_ORDERS_SUCCESS,
    });
    callback && callback();
  } catch (error) {
    yield put({
      type: RESEND_ORDERS_FAILED,
      error: error.message,
    });
  }
}

export function* getPostOrders(actions: any): unknown {
  const {callback} = actions.payload;
  try {
    const {response} = yield OrdersRepository.getPostOrders(actions);
    yield put({
      type: GET_POST_ORDERS_SUCCESS,
      data: response.data,
    });
    callback && callback();
    handleNotfication('سفارش های پستی شما با موفقیت ارسال شد', 'success');
  } catch (error) {
    yield put({
      type: GET_POST_ORDERS_FAILED,
      error: error.message,
    });
    handleNotfication('سفارش های پستی شما ارسال نشد', 'error');
  }
}

export function* cancelOrder(actions: any): unknown {
  const {id, body, pagination} = actions.payload;
  try {
    yield OrdersRepository.cancelOrder(actions);
    yield put({
      type: CANCEL_ORDER_SUCCESS,
    });
    yield put({
      type: GET_ORDERS,
      payload: {...pagination, sort: 'created,desc'},
    });
    handleNotfication('سفارش مورد نظر شمابا موفقیت لغو شد', 'success');
  } catch (error) {
    yield put({
      type: CANCEL_ORDER_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* deletePostOrder(actions: any): unknown {
  const {pagination, callback} = actions.payload;
  try {
    yield OrdersRepository.deletePostOrder(actions);
    yield put({
      type: DELETE_POST_ORDER_SUCCESS,
    });
    yield put({
      type: GET_ORDERS,
      payload: {...pagination, sort: 'created,desc'},
    });
    callback && callback();
    handleNotfication('سفارش مورد نظر شما با موفقیت حذف شد', 'success');
  } catch (error) {
    yield put({
      type: DELETE_POST_ORDER_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getLogs(actions: any): unknown {
  try {
    const response = yield OrdersRepository.getLogs(actions);
    yield put({
      type: GET_LOGS_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_LOGS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getAllOrdersReport(actions: any): unknown {
  try {
    const response = yield OrdersRepository.getAllOrdersReport(actions);
    yield put({
      type: GET_ALL_ORDERS_REPORT_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_ALL_ORDERS_REPORT_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateAllOrderStatus(actions: any): unknown {
  const {pagination} = actions.payload;
  try {
    yield OrdersRepository.updateAllOrderStatus(actions);
    yield put({
      type: UPDATE_ALL_ORDER_STATUS_SUCCESS,
    });

    yield put({
      type: GET_ORDERS,
      payload: {...pagination, sort: 'created,desc'},
    });
  } catch (error) {
    yield put({
      type: UPDATE_ALL_ORDER_STATUS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export default function* orderSaga() {
  yield takeLatest(GET_ORDERS, getOrders);
  yield takeLatest(GET_VITRIN_ORDERS, getVitrinOrders);
  yield takeLatest(GET_INCOMING_ORDERS, getIncomingOrders);
  yield takeLatest(GET_TICKETS, getTickets);
  yield takeLatest(GET_TICKET, getTicket);
  yield takeLatest(CLOSE_TICKET, closeTicket);
  yield takeLatest(GET_TICKETCOUNT, getTicketsCount);
  yield takeLatest(GET_CAT, getCatgories);
  yield takeLatest(GET_ORDER_WITH_ID, getOrderWithId);
  yield takeLatest(GET_VITRIN_ORDER_WITH_ID, getVitrinOrderWithId);
  yield takeLatest(UPDATE_ORDER_STATUS, updateOrderStatus);
  yield takeLatest(CREATE_POST_ORDERS, createPostOrder);
  yield takeLatest(GET_POST_ORDERS, getPostOrders);
  yield takeLatest(UPDATE_ALL_ORDER_STATUS, updateAllOrderStatus);
  yield takeLatest(ACTION_RETRIEVE_RUBIKA_ORDERS, actionRetrieveRubikaOrders);
  yield takeLatest(SCHEDULE_ORDERS, scheduleOrdersSaga);
  yield takeLatest(CANCEL_ORDER, cancelOrder);
  yield takeLatest(DELETE_POST_ORDER, deletePostOrder);
  yield takeLatest(GET_LOGS, getLogs);
  yield takeLatest(CREATE_ORDER_ITEMS, createOrderItems);
  yield takeLatest(GET_ALL_ORDERS_REPORT, getAllOrdersReport);
  yield takeLatest(GET_ORDER_ITEMS, getAllOrderItems);
  yield takeLatest(UPDATE_ORDER, updateOrder);
  yield takeLatest(RESEND_ORDER, resendOrders);
}
